import { get } from 'lodash';
import React from 'react';

import SelectPaymentScheduleSection from '../FormSteps/SelectPaymentScheduleSection';
import SelectPayrollFileSection from '../FormSteps/SelectPayrollFileSection';

const RefreshPayrollFileStepGroup = ({ t, currentStep, loading, values, onValuesChange }) => {
  if (get(values, 'actionType') !== 'refresh') return null;

  return (
    <>
      <SelectPaymentScheduleSection
        t={t}
        step={2}
        currentStep={currentStep}
        loading={loading}
        onValuesChange={onValuesChange}
        value={get(values, 'paymentScheduleId')}
      />

      <SelectPayrollFileSection
        t={t}
        step={3}
        currentStep={currentStep}
        loading={loading}
        selectedPayrollFile={get(values, 'payrollAuditId')}
        onValuesChange={onValuesChange}
      />
    </>
  );
};

export default RefreshPayrollFileStepGroup;
